<template lang="pug">
  div
    multiselect(
      v-model="selectedCriteria"
      open-direction="bottom"
      :options="placeCriteria"
      label="label"
      track-by="value"
      :show-labels="false"
      :placeholder="translations.specialcriteria"
      :searchable="false"
    )
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },

  props: {
    placeCriteria: {
      type: Array,
      required: true
    },

    value: {
      type: String,
      required: true
    },

    translations: {
      type: Object,
      required: true
    }

  },

  data () {
    return {
      selectedCriteria: this.value || []
    }
  },

  watch: {
    selectedCriteria () {
      let value = ""
      if (this.selectedCriteria) {
        value = this.selectedCriteria.value
      }

      this.$emit('input', value)
    }
  },

  created () {
    this.selectedCriteria = this.placeCriteria.find(placeCriteria => placeCriteria.value === this.value)
  }
}
</script>
